import React from 'react';
import { LookupImportTemplate } from 'themes/modules/lookup/pages';
import { inject } from 'mobx-react';

@inject(i => ({
	lookupViewStore: i.rootStore.lookupViewStore,
}))
class LookupImport extends React.Component {
	render() {
		return <LookupImportTemplate {...this.props} />;
	}
}

export default LookupImport;



// WEBPACK FOOTER //
// ./src/modules/lookup/pages/LookupImport.jsx